/**
 * 生成请求路由配置：逻辑 modelId -> 实际提交的渠道（Pollo / AllAll / 后续可扩展其他平台）
 *
 * 新增逻辑模型：在此增加 LOGICAL_ROUTES[modelId]，可选 pollo / allall / allallOnly。
 * 新增平台（如 Minimax）：在 LOGICAL_ROUTES 中增加 platformKey（如 minimax: 'model-id'），
 * 在 api/ai 下实现 submitXxx、pollXxx，在 generateContent 中增加对 route.minimax 的分发即可。
 */
import {
  submitPolloModel,
  submitAllallVeo3,
  submitAllallVeo31,
  submitAllallSora2,
  submitAllallWan25
} from './ai'

function hasImageFile(params) {
  return params.referenceImageFile && typeof File !== 'undefined' && params.referenceImageFile instanceof File
}

function hasImageUrl(params) {
  return params.referenceImage && typeof params.referenceImage === 'string' && params.referenceImage.trim().length > 0
}

function withFileAsReference(params) {
  return Object.assign({}, params, { referenceImage: params.referenceImageFile })
}

/**
 * 逻辑模型 -> 路由
 * - pollo: 走 Pollo 时使用的实际 modelId（需在 AI_MODEL_PATHS 中存在）
 * - allall: 可选，当配置为 allall 且 condition 通过时走 AllAll
 *   - logicalKey: 用于 getLogicalModelProvider(logicalKey) === 'allall'
 *   - condition: (params) => boolean
 *   - submit: (params) => Promise
 *   - transformParams: 可选 (params) => params，提交前转换参数
 * - allallOnly: 仅 AllAll，无 Pollo 回退；需配合 condition、submit、transformParams
 */
export var LOGICAL_ROUTES = {
  'veo-3': {
    pollo: 'veo-3-pollo',
    allall: {
      logicalKey: 'veo-3',
      condition: function (params) { return hasImageFile(params) },
      submit: submitAllallVeo3,
      transformParams: withFileAsReference
    }
  },
  'sora-2': {
    pollo: 'sora-2-pollo',
    allall: {
      logicalKey: 'sora-2',
      condition: function (params) { return hasImageFile(params) },
      submit: submitAllallSora2,
      transformParams: withFileAsReference
    }
  },
  'sora-2-allall': {
    allallOnly: true,
    condition: function (params) { return hasImageFile(params) },
    submit: submitAllallSora2,
    transformParams: withFileAsReference
  },
  'veo-3-0': {
    pollo: 'veo-3-pollo'
  },
  'veo-3-1': {
    pollo: 'veo-3-1',
    allall: {
      logicalKey: 'veo-3-1',
      condition: function (params) { return hasImageFile(params) },
      submit: submitAllallVeo31,
      transformParams: withFileAsReference
    }
  },
  'veo-3-1-fast': {
    pollo: 'veo-3-1-fast'
  },
  'wan-2-5': {
    pollo: 'wan-2-5-preview',
    allall: {
      logicalKey: 'wan-2-5',
      condition: function (params) { return hasImageUrl(params) },
      submit: submitAllallWan25
    }
  },
  'seedance': {
    pollo: 'seedance-1-5-pro'
  },
  'kling-2-5': {
    pollo: 'kling-v2-5-turbo'
  },
  'kling-2-6': {
    pollo: 'kling-v2-6'
  },
  'hailuo-2-3': {
    pollo: 'minimax-hailuo-2-3'
  },
  'runway': {
    pollo: 'runway-gen-4-turbo'
  },
}

export function getLogicalRoute(modelId) {
  return LOGICAL_ROUTES[modelId] || null
}
